var swiper = new Swiper(".block__other-brand-logo", {
    slidesPerView: 8,
    spaceBetween: 10,
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
    },
    mousewheel: {
        forceToAxis: true,
    },
    navigation: {
        nextEl: '.swiper-buttons-next',
        prevEl: '.swiper-buttons-prev',
    },
    breakpoints: {
        180: {
            slidesPerView: 1.5,
            spaceBetween: 10,
        },
        300: {
            slidesPerView: 2.8,
            spaceBetween: 10,
        },
        400: {
            slidesPerView: 3.5,
            spaceBetween: 10,
        },
        749: {
            slidesPerView: 2.5,
            spaceBetween: 10,
        },
        991: {
            slidesPerView: 5,
            spaceBetween: 10,
        },
        1100: {
            slidesPerView: 6,
            spaceBetween: 10,
        },
        1500: {
            slidesPerView: 8,
            spaceBetween: 10,
        }
    },
});